import React        from 'react';
import { guid }          from 'rewire-common';
import { Observe }       from 'rewire-core';
import {
  withStyles,
  ToggleMenu,
  IToggleMenuProps,
}                        from 'rewire-ui';
import { PopoverOrigin } from '@material-ui/core/Popover';
import { Theme }         from '@material-ui/core/styles';
import MoreHorizIcon     from '@material-ui/icons/MoreHoriz';

const styles = (_theme: Theme) => ({
  menuButton: {
    marginLeft: '10px',
    padding: '0px',
    minWidth: '0px',
    minHeight: '0px',
    // '&:hover, &:active': {
    //   background: 'transparent',
    // },
  },
  menu: {
  },
  menuTitleContainer: {
  },
  listItemText: {
  },
  listItemTypography: {
  },
  listItemIcon: {
  },
  menuItem: {
  },
  menuItemSelected: {
  },
  menuItemDisabled: {
  },
});

export interface IOptionsToggleMenuProps {
  menuId?:        string;
  buttonContent?: JSX.Element;
}

export type OptionsToggleMenuProps = IOptionsToggleMenuProps & Omit<IToggleMenuProps, 'menuId' | 'buttonContent'>;

class OptionsToggleMenu extends React.Component<OptionsToggleMenuProps> {
  constructor(props: OptionsToggleMenuProps) {
    super(props);
  }

  render() {
    const menuId                         = this.props.menuId || guid();
    const buttonContent                  = this.props.buttonContent || <MoreHorizIcon />;
    const buttonProps                    = {disableRipple: true, ...this.props.buttonProps};
    const anchorOrigin:    PopoverOrigin = this.props.anchorOrigin    || {vertical: 'bottom', horizontal: 'right'};
    const transformOrigin: PopoverOrigin = this.props.transformOrigin || {vertical: 'top',    horizontal: 'right'};

    return <Observe render={() => (
      <ToggleMenu
        menuId={menuId}
        buttonContent={buttonContent}
        buttonProps={buttonProps}
        getContentAnchorEl={null}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        {...this.props as any}
      />
    )} />;
  }
}

export default withStyles(styles, OptionsToggleMenu);
